module.exports = __webpack_public_path__ + "static/media/CF.92d0ac08.webp";